import { NavLink } from "react-router-dom";
import {
  ChevronRight,
  Heart,
  IdCard,
  Lock,
  User,
  Wallet,
  BookOpen,
  Bookmark,
  Gift,
} from "lucide-react";

const items = [
  {
    to: "/dashboard/profile/setting",
    label: "Profile Settings",
    icon: <User className="w-4 h-4" />,
  },
  {
    to: "/dashboard/profile/affiliate-program",
    label: "Referral Program",
    icon: <Gift className="w-4 h-4" />,
  },
  {
    to: "/assets/wallet",
    label: "Wallet",
    icon: <Wallet className="w-4 h-4" />,
  },
  {
    to: "/dashboard/profile/membership-level",
    label: "Membership Level",
    icon: <IdCard className="w-4 h-4" />,
  },
  {
    to: "/dashboard/profile/password-setting",
    label: "Password Settings",
    icon: <Lock className="w-4 h-4" />,
  },
  // {
  //   to: "/dashboard/profile/notification-setting",
  //   label: "Notification Settings",
  //   icon: <Bell className="w-4 h-4" />,
  // },
  {
    to: "/dashboard/profile/help-and-support",
    label: "Help & Support",
    icon: <Heart className="w-4 h-4" />,
  },
  {
    to: "/dashboard/profile/course-and-chapter-completion-history",
    label: "Course & Chapter Completion History",
    icon: <BookOpen className="w-4 h-4" />,
  },
  {
    to: "/dashboard/profile/certificate-and-achievement",
    label: "Certificates & Achievements",
    icon: <Bookmark className="w-4 h-4" />,
  },
];

export default function ProfileNav() {
  return (
    <div className="rounded-xl bg-main-dark">
      <nav className="space-y-1">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `flex items-center justify-between w-full px-3 py-2 rounded-lg text-sm transition-colors ${isActive ? "bg-white/10" : "hover:bg-white/5"}`
            }>
            <span className="flex items-center gap-2">
              {item.icon}
              <span>{item.label}</span>
            </span>

            <ChevronRight className="w-4 h-4 text-white" />
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
